import { LOCAL_STORAGE_DISABLED_ERROR } from 'appConstants';

/** Interface to Local Storage Override values */
class LocalOverrides {
  /** Retrieve overrides from local storage as array of strings */
  static get keys(): Set<string> {
    try {
      const overridesStr = localStorage.getItem('feature-overrides') || '';
      return new Set(overridesStr ? overridesStr.split(' ') : []);
    } catch {
      console.error(LOCAL_STORAGE_DISABLED_ERROR);
      return new Set();
    }
  }

  /** Write overrides to local storage */
  static set keys(value: Set<string>) {
    if (!value) {
      return;
    }

    try {
      // Remove duplicates and convert to space delimited string
      const keys = Array.from(value).join(' ');
      localStorage.setItem('feature-overrides', keys);
    } catch {
      console.error(LOCAL_STORAGE_DISABLED_ERROR);
    }
  }

  /** Add key to overrides if it does not exist */
  static add(key: string) {
    const keys = LocalOverrides.keys;

    if (keys.has(key)) {
      return;
    }

    LocalOverrides.keys = keys.add(key);
  }

  /** Return boolean indicating if key is currently in overrides */
  static has(key: string) {
    return LocalOverrides.keys.has(key);
  }

  /** Remove key from overrides if it exists */
  static remove(key: string) {
    const keys = LocalOverrides.keys;
    const removed = keys.delete(key);

    if (removed) {
      LocalOverrides.keys = keys;
    }
  }
}

export { LocalOverrides };
